import { useContext } from 'react';
import { FormContext } from '../form';
export var useIsInForm = function useIsInForm() {
  var formContext = useContext(FormContext);
  if (formContext === null) {
    return false;
  }
  return true;
};